export default __webpack_public_path__ + "static/media/men-logo.7875f223.svg";